import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconKMSImageIcon from '../../../assets/icons/IconKMSImageIcon';
import IconKMSUpload from '../../../assets/icons/IconKMSUpload';

import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import Select from 'react-select';
import RadioTab from '../../../components/Radio/RadioTab';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_KMS from '../../../api/apiKMS';
import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import { last } from 'lodash';
import MasterDataUserAlert from '../../../components/MasterData/MasterDataUserAlert';
import MENU_KMS from '../../../constants/menuKMSConstant';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import { CheckPermissionComponent } from '../../../util/permission';
import { SETTING_KMS_DELETE, SETTING_KMS_UPDATE } from '../../../constants/menuPermissionConstant';

const validationCategory = MENU_KMS.validationCategory;

class KMSCategoryDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataCategoryKMS: {
                id: "",
                category: "",
                type: { label: "", value: "" },
                level: { label: "", value: "" },
                parentId: null,
                iconFile: null,
                lastLevel: "",
                status: "",
            },
            createdAt: "",
            updatedAt: "",
            checkboxEditKMS: false,
            errorMessage: "",
            showErrorAlertResponse: false,
            showConfirmAlert: false,
            showSuccessAlert: false,
            showPopupImage: false,
            disableKMSListMenu: true,
            disableEditPage: true,
            showAlertKMSCategory: false,
            showAlertKMSCategoryRegex: false,
            showAlertKMSCategoryMaxChar: false,
            showAlertType: false,
            showAlertLevel: false,
            showAlertParent: false,
            showSuccessDeleteAlert: false,
            showConfirmDeleteAlert: false,
            historyDataCategoryKMS: null,
        }
        this.containerRef = createRef();
    }

    componentDidMount() {
        this.getDetailCategoryKMS();
    }

    redirectToKMSPage = () => {
        this.props.history.goBack();
    }

    handleChangeDisableMenu = value => {
        if (value === false) {
            return this.setState({
                disableKMSListMenu: true
            })
        }
        this.setState({
            disableKMSListMenu: false
        })
    }

    handleChange = e => {
        this.setState({
            dataCategoryKMS: {
                ...this.state.dataCategoryKMS,
                [e.target.name]: e.target.value,
            }
        })
    }

    handleChangeType = data => {
        this.setState({
            dataCategoryKMS: {
                ...this.state.dataCategoryKMS,
                type: data
            }
        })
    }

    handleChangeLevel = data => {
        this.setState({
            dataCategoryKMS: {
                ...this.state.dataCategoryKMS,
                level: data
            }
        })
    }

    handleChangeParent = data => {
        this.setState({
            dataCategoryKMS: {
                ...this.state.dataCategoryKMS,
                parentId: data
            }
        })
    }

    handleChangeAttachment = e => {
        let tempFile = e.target.files[0];

        if (!tempFile) {
            e.target.value = null;
            return
        }

        if (tempFile.type !== "image/jpeg" && tempFile.type !== "image/png" && tempFile.type !== "image/jpg") {
            e.target.value = null;
            return this.setState({
                errorMessage: "File yang dipilih bukan file gambar (JPEG, PNG & JPG). silahkan pilih file lain",
                showErrorAlertResponse: true
            });
        }

        if (tempFile.size / 1024 / 1024 >= 2) {
            e.target.value = null;
            return this.setState({
                errorMessage: `Maksimal Ukuran file 2Mb!`,
                showErrorAlertResponse: true
            });
        }

        this.setState({
            dataCategoryKMS: {
                ...this.state.dataCategoryKMS,
                iconFile: tempFile,
            }
        });
    }

    handleCheck = e => {
        this.setState({
            dataCategoryKMS: {
                ...this.state.dataCategoryKMS,
                [e.target.name]: e.target.value,
            }
        })
    }

    handleSave = () => {
        // If Have error return Alert and Not Continue to the processing data and HIT API
        if (this.handleValidationField()) {
            return this.containerRef.current.scrollIntoView({ behavior: 'smooth' })
        }
        this.setState({ showConfirmAlert: true, checkboxEditKMS: false });
    }

    handleValidationField = () => {
        let isFieldError = false;
        this.setState({
            showAlertKMSCategory: false,
            showAlertKMSCategoryRegex: false,
            showAlertType: false,
            showAlertLevel: false,
            showAlertParent: false,
            showAlertKMSCategoryMaxChar: false,
        })

        if (this.state.dataCategoryKMS.category.length > 256) {
            this.setState({ showAlertKMSCategoryMaxChar: true })
            isFieldError = true;
        }

        if (!validationCategory.test(this.state.dataCategoryKMS.category)) {
            this.setState({ showAlertKMSCategoryRegex: true })
            isFieldError = true;
        }

        if (this.state.dataCategoryKMS.category === "") {
            this.setState({ showAlertKMSCategory: true })
            isFieldError = true;
        }

        if (this.state.dataCategoryKMS.type.value === "") {
            this.setState({ showAlertType: true })
            isFieldError = true;
        }

        if (this.state.dataCategoryKMS.level.value === "") {
            this.setState({ showAlertLevel: true })
            isFieldError = true;
        }

        if (this.state.dataCategoryKMS.parentId === null && this.state.dataCategoryKMS.level.value !== 1) {
            this.setState({ showAlertParent: true })
            isFieldError = true;
        }

        return isFieldError;
    }

    handleEditCategoryKMS = () => {
        this.setState({ showConfirmAlert: false });
        let bodyFormData = new FormData();

        const data = {
            category: this.state.dataCategoryKMS.category,
            type: this.state.dataCategoryKMS.type.value,
            level: this.state.dataCategoryKMS.level.value,
            parent_id: this.state.dataCategoryKMS.parentId?.value || 0,
            last_level: this.getBooleanData(this.state.dataCategoryKMS.lastLevel),
            status: this.getBooleanData(this.state.dataCategoryKMS.status),
            delete_foto: this.state.dataCategoryKMS.iconFile ? false : true,
            updated_at: this.state.updatedAt
        }

        bodyFormData.append('photo1', this.state.dataCategoryKMS.iconFile);
        bodyFormData.append('content', JSON.stringify(data));

        API_KMS.putDataEditCategoryKMS(this.state.dataCategoryKMS.id, bodyFormData, this.props.token)
            .then(res => {
                this.setState({
                    showConfirmAlert: false,
                    showSuccessAlert: true,
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))

    }

    successEditCategoryKMS = () => {
        this.setState({ showSuccessAlert: false });
        if (this.state.checkboxEditKMS) {
            return this.props.history.push({ pathname: ROUTER_CONSTANT.SETTINGS_KMS_LIST_ADD, state: { categoryKMSDetail: this.state.dataCategoryKMS } });
        }
        this.props.history.push(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY);
    }

    successDeleteCategoryKMS = () => {
        this.setState({ showSuccessDeleteAlert: false });
        this.props.history.push(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY);
    }

    getBooleanData = value => {
        if (value === "false") {
            return false;
        }
        return true;
    }

    handleCheckboxEditKMS = e => {
        this.setState({ checkboxEditKMS: e.target.checked })
    }

    disableCheckbox = value => {
        if (value === "false") {
            return true;
        }
        return false;
    }

    handleDeleteCategoryKMS = () => {
        const data = {
            updated_at: this.state.updatedAt
        }
        API_KMS.DeleteDataCategoryKMS(this.props.match.params.id, data, this.props.token)
            .then(res => {
                this.setState({
                    showConfirmDeleteAlert: false,
                    showSuccessDeleteAlert: true,
                })
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmDeleteAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
            }))
    }

    getDetailCategoryKMS = () => {
        API_KMS.getDetailCategoryKMS(this.props.match.params.id, this.props.token)
            .then(res => {
                // Get parent value and label by Id
                if (getContent(res).level !== 1) {
                    this.getParentValue(getContent(res).parent_id);
                }
                this.setState({
                    dataCategoryKMS: {
                        id: getContent(res).id,
                        category: getContent(res).category,
                        type: this.getTypeFunction(getContent(res).type),
                        level: this.getLevelFunction(getContent(res).level),
                        iconFile: getContent(res).icon_link,
                        lastLevel: String(getContent(res).last_level),
                        status: String(getContent(res).status),
                    },
                    createdAt: getContent(res).created_at,
                    updatedAt: getContent(res).updated_at,
                    disableKMSListMenu: !getContent(res).last_level,
                },
                    () => {
                        this.setState({ historyDataCategoryKMS: this.state.dataCategoryKMS })
                    }
                );
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                if (err.response.data.nexsoft.payload.status.message === "Data id tidak diketahui") {
                    this.redirectToKMSPage();
                    setTimeout(() => alert('Data tidak ditemukan!'), 1000);
                }
            }))
    }

    getParentValue = (id) => {
        if (id === 0) {
            return null;
        }
        API_KMS.getDetailCategoryKMS(id, this.props.token).then(
            res => {
                let tempData = { value: getContent(res).id, label: getContent(res).category }
                this.setState({ dataCategoryKMS: { ...this.state.dataCategoryKMS, parentId: tempData } });
            }
        ).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
            this.redirectToKMSPage();
        }))
    }

    getTypeFunction = value => {
        switch (value) {
            case "C":
                return { label: "FAQ Chatbot", value: "C" };
            case "I":
                return { label: "FAQ Internal", value: "I" };
            case "B":
                return { label: "Both", value: "B" };
            default:
                return { label: "", value: "" };
        }
    }

    getLevelFunction = value => {
        switch (value) {
            case 1:
                return { label: "1", value: 1 };
            case 2:
                return { label: "2", value: 2 };
            case 3:
                return { label: "3", value: 3 };
            case 4:
                return { label: "4", value: 4 };
            case 5:
                return { label: "5", value: 5 };
            case 6:
                return { label: "6", value: 6 };
            case 7:
                return { label: "7", value: 7 };
            case 8:
                return { label: "8", value: 8 };
            case 9:
                return { label: "9", value: 9 };
            default:
                return { label: "", value: "" };
        }
    }

    getFilenameFromUrl = value => {
        if (value) {
            return last(value.split("/"));
        }
    }

    handleListKMSMenu = () => {
        this.props.history.push({ pathname: ROUTER_CONSTANT.SETTINGS_KMS_LIST, state: { categoryKMSDetail: this.state.historyDataCategoryKMS } });
    }

    confirmationDescription = () => {
        return (
            <div className="space-y-3">
                <p>Data otomatis akan tersimpan di KMS</p>
                <div className="flex justify-center items-center space-x-2">
                    <input type="checkbox" disabled={this.disableCheckbox(this.state.dataCategoryKMS.lastLevel)} onChange={this.handleCheckboxEditKMS} />
                    <label className={this.disableCheckbox(this.state.dataCategoryKMS.lastLevel) ? "text-gray-400" : "text-gray-700"}>Tambah daftar KMS</label>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div ref={this.containerRef} className="space-y-3">
                <BreadCrumbs
                    parentMenu="Pengaturan"
                    serviceMenu="KMS"
                    menuItem="Detail KMS"
                    title="Knowledge Management Sistem"
                />

                {/* WHITECONTAINER */}
                <div className="white-container pb-24">
                    <div className="w-full bg-white border border-gray-300 rounded-lg p-8">
                        {/* MENU HEADBAR */}
                        <div className="flex items-center space-x-5 text-2xl text-gray-700 pb-10">
                            <button id="btncategorykms" className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_CATEGORY) ? "active-menu-kms font-medium" : "font-medium"}>
                                Kategori KMS
                            </button>
                            <button id="btnlistkms" className={`
                                ${window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS_LIST) ? "active-menu-kms font-medium" : "font-medium"}
                                ${this.state.disableKMSListMenu ? "text-gray-400 cursor-default" : "cursor-pointer"}
                            `}
                                onClick={() => this.handleListKMSMenu()}
                                disabled={this.state.disableKMSListMenu}
                            >
                                Daftar KMS
                            </button>
                        </div>
                        {/* CONTENT  MENU */}
                        <div className="relative">
                            {/* Form */}
                            <div className="space-y-4">
                                <div className="w-3/12 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">ID</p>
                                    </div>
                                    <input
                                        type="text"
                                        name="id"
                                        className="form-control w-full"
                                        defaultValue={this.state.dataCategoryKMS.id}
                                        disabled={true}
                                    />
                                </div>

                                <div className="w-3/12 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Kategori</p>
                                        <span className="text-darkred">*</span>
                                    </div>
                                    <input
                                        id="tslcategorykms"
                                        type="text"
                                        name="category"
                                        placeholder="Tulis Kategori KMS"
                                        className="form-control w-full"
                                        onChange={this.handleChange}
                                        value={this.state.dataCategoryKMS.category}
                                        maxLength={256}
                                        disabled={this.state.disableEditPage}
                                    />
                                    {this.state.showAlertKMSCategory && <MasterDataUserAlert text="Kategori KMS tidak boleh kosong!" />}
                                    {this.state.showAlertKMSCategoryRegex && <MasterDataUserAlert text="Kategori KMS tidak boleh mengandung spesial karakter" />}
                                    {this.state.showAlertKMSCategoryMaxChar && <MasterDataUserAlert text="Jumlah karakter harus lebih kecil dari 256" />}
                                </div>

                                <div className="w-3/12 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Tipe</p>
                                        <span className="text-darkred">*</span>
                                    </div>
                                    <Select
                                        inputId="ddltype"
                                        name="type"
                                        options={MENU_KMS.typeOptions}
                                        placeholder="Pilih Tipe"
                                        components={{ IndicatorSeparator: () => null }}
                                        className="w-full"
                                        maxMenuHeight={170}
                                        onChange={this.handleChangeType}
                                        value={this.state.dataCategoryKMS.type}
                                        isDisabled={this.state.disableEditPage}
                                    />
                                    {this.state.showAlertType && <MasterDataUserAlert text="Tipe tidak boleh kosong!" />}
                                </div>

                                <div className="w-3/12 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Level</p>
                                        <span className="text-darkred">*</span>
                                    </div>
                                    <Select
                                        inputId="ddllevel"
                                        name="level"
                                        options={MENU_KMS.levelOptions}
                                        placeholder="Pilih Level"
                                        components={{ IndicatorSeparator: () => null }}
                                        className="w-full"
                                        maxMenuHeight={170}
                                        value={this.state.dataCategoryKMS.level}
                                        isDisabled={true}
                                    />
                                    {this.state.showAlertLevel && <MasterDataUserAlert text="Level tidak boleh kosong!" />}
                                </div>

                                <div className="w-3/12 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Parent</p>
                                        <span className={this.state.dataCategoryKMS.level.value === 1 || this.state.dataCategoryKMS.level.value === "" ? "hidden" : "text-darkred"}>*</span>
                                    </div>
                                    <Select
                                        inputId="ddsparentcategory"
                                        name="parentId"
                                        placeholder="Pilih Parent"
                                        components={{ IndicatorSeparator: () => null }}
                                        className="w-full"
                                        maxMenuHeight={170}
                                        value={this.state.dataCategoryKMS.parentId}
                                        isDisabled={true}
                                    />
                                    {(this.state.dataCategoryKMS.level.value !== 1 && this.state.showAlertParent) && <MasterDataUserAlert text="Parent tidak boleh kosong!" />}
                                </div>

                                <div className="w-3/12 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Icon</p>
                                    </div>
                                    {!this.state.dataCategoryKMS.iconFile ?
                                        <div className="flex justify-center items-center outline-none border-2 border-gray-300 border-dashed p-5 focus:outline-none">
                                            <div className="flex flex-col items-center w-full relative space-y-2 text-center text-gray-600">
                                                <IconKMSUpload />
                                                <p className="font-bold text-xl">Tarik dan letakkan gambar disini</p>
                                                <p className="">Jenis file : JPG</p>
                                                <p className="font-semibold">Atau</p>
                                                <button className={`${this.state.disableEditPage ? "bg-darkgrey" : "bg-olddarkblue"} text-white px-2 py-1 rounded-lg font-medium`}>Cari File</button>
                                                <input id="btnattachfile" type="file" className="w-full h-full absolute top-0 left-0 opacity-0" accept="image/png, image/jpg, image/jpeg" onChange={this.handleChangeAttachment} disabled={this.state.disableEditPage} />
                                            </div>
                                        </div>
                                        :
                                        <div className={`${this.state.disableEditPage ? "bg-darkgrey" : "bg-gray-100"} flex justify-between p-2 rounded-lg shadow-box-button  text-gray-600`}>
                                            <div className="flex items-center">
                                                <div className="mr-2">
                                                    <IconKMSImageIcon />
                                                </div>
                                                <div className="w-52">
                                                    {(typeof this.state.dataCategoryKMS.iconFile) !== "string" ?
                                                        <>
                                                            <p className="text-lg truncate" title={this.state.dataCategoryKMS.iconFile.name}>{this.state.dataCategoryKMS.iconFile.name}</p>
                                                            <p className="text-sm">{Math.round(this.state.dataCategoryKMS.iconFile.size / 1024 / 1024 * 100) / 100} MB</p>
                                                        </>
                                                        :
                                                        <>
                                                            <p className="text-lg truncate" title={this.getFilenameFromUrl(this.state.dataCategoryKMS.iconFile)}>{this.getFilenameFromUrl(this.state.dataCategoryKMS.iconFile)}</p>
                                                        </>
                                                    }
                                                    <p id="btnviewpicture" className="cursor-pointer text-blue-500" onClick={() => this.setState({ showPopupImage: true })}>Lihat Icon</p>
                                                </div>
                                            </div>
                                            <div className="flex justify-end mt-1 mr-3">
                                                {!this.state.disableEditPage && <FontAwesomeIcon icon={faTimes} className="text-2xl cursor-pointer" onClick={() => { this.setState({ dataCategoryKMS: { ...this.state.dataCategoryKMS, iconFile: null } }) }} />}
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className="w-3/12 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Kategori Terkecil</p>
                                        <span className="text-darkred">*</span>
                                    </div>
                                    <RadioTab id="tglsmallestcategory" radioInputName="lastLevel" dataOption={MENU_KMS.dataLastLevel} defaultCheck={this.state.dataCategoryKMS.lastLevel} onChange={this.handleCheck} disabled={this.state.disableEditPage} />
                                </div>

                                <div className="w-3/12 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Status</p>
                                        <span className="text-darkred">*</span>
                                    </div>
                                    <RadioTab id="tglstatus" radioInputName="status" dataOption={MENU_KMS.dataStatus} defaultCheck={this.state.dataCategoryKMS.status} onChange={this.handleCheck} disabled={this.state.disableEditPage} />
                                </div>
                            </div>

                            {/* Button */}
                            <div className="flex space-x-5 absolute -bottom-24 -right-8">
                                {this.state.disableEditPage ?
                                    <>
                                        <CheckPermissionComponent permissionConstant={[SETTING_KMS_DELETE]} userPermission={this.props.userDetail.permissions}>
                                            <button id="btndelete" className="border border-olddarkblue bg-transparent text-olddarkblue py-2 px-6 rounded-lg font-medium" onClick={() => this.setState({ showConfirmDeleteAlert: true })}>Hapus</button>
                                        </CheckPermissionComponent>
                                        <CheckPermissionComponent permissionConstant={[SETTING_KMS_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                            <button id="btnedit" className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={() => this.setState({ disableEditPage: false })}>Ubah</button>
                                        </CheckPermissionComponent>
                                    </>
                                    :
                                    <>
                                        <button id="btncancel" className="border border-olddarkblue bg-transparent text-olddarkblue py-2 px-6 rounded-lg font-medium" onClick={this.redirectToKMSPage}>Batal</button>
                                        <button id="btnsave" className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={this.handleSave}>Simpan</button>
                                    </>
                                }
                            </div>

                            {/* Popup Modal Image */}
                            <div className={this.state.showPopupImage ? "block" : "hidden"}>
                                <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                                    <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none w-5/12 min-w-min">
                                        <div className="body-attachment w-full flex rounded-lg flex-col p-8 font-bold text-lg space-y-5">
                                            <div>
                                                {(typeof this.state.dataCategoryKMS.iconFile) !== "string" ?
                                                    <div className="text-2xl">{this.state.dataCategoryKMS.iconFile ? this.state.dataCategoryKMS.iconFile.name : ""}</div>
                                                    :
                                                    <div className="text-2xl">{this.state.dataCategoryKMS.iconFile && this.getFilenameFromUrl(this.state.dataCategoryKMS.iconFile)}</div>
                                                }
                                            </div>
                                            <div className="flex justify-center items-center">
                                                {(typeof this.state.dataCategoryKMS.iconFile) !== "string" ?
                                                    <img src={this.state.dataCategoryKMS.iconFile && URL.createObjectURL(this.state.dataCategoryKMS.iconFile)} alt={this.state.dataCategoryKMS.iconFile ? this.state.dataCategoryKMS.iconFile.name : ""} className="h-96" />
                                                    :
                                                    <img src={this.state.dataCategoryKMS.iconFile && this.state.dataCategoryKMS.iconFile} alt={"icon file"} className="h-96" />
                                                }
                                            </div>
                                            <div className="flex justify-center items-center">
                                                <button id="btncloseviewicon" className="bg-olddarkblue text-white py-2 px-6 rounded-lg font-medium" onClick={() => this.setState({ showPopupImage: false })}>Tutup</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                            </div>

                            {/* Alert */}
                            <Alert show={this.state.showConfirmAlert} button={true} title="Mengubah Kategori?" desc={this.confirmationDescription()} close={() => this.setState({ showConfirmAlert: false })} submit={() => this.handleEditCategoryKMS()} />
                            <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil" desc={"Data berhasil diubah"} close={this.successEditCategoryKMS} ok />
                            <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                            <Alert show={this.state.showSuccessDeleteAlert} icon="success" title="Berhasil" desc={"Data berhasil dihapus"} close={this.successDeleteCategoryKMS} ok />
                            <Alert show={this.state.showConfirmDeleteAlert} button={true} title="Hapus Kategori KMS?" desc={"Apakah Anda yakin ingin menghapus data?"} close={() => this.setState({ showConfirmDeleteAlert: false })} submit={() => this.handleDeleteCategoryKMS()} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(KMSCategoryDetail);